import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: "",
  isSelectAllChecked: false,
  showTable: false,
  searchFilterValue: "",
  districtList: [],
  storeNumberList: [],
  laborCodeList: [],
  statusList: [],
  tableSearchFields: {
    district: [],
    storeNumber: [],
    laborCode: [],
    status: [],
    accountNumber: "",
    accountName: "",
    priceType: { id: null, label: "", description: "" },
    job: { id: null, label: "", description: "" },
    parentNumber: "",
  },
  exceptionPriceSearchFields: {
    storeNumber: "",
    accountNumber: "",
    accountName: "",
    job: { id: null, label: "", description: "" },
  },
  tableList: [],
  exceptionPriceSearchList: [],
  showPriceTable: false,
  isExpPrice: false,
};

const laborTable = createSlice({
  name: "laborTable",
  initialState,
  reducers: {
    updateSearchFields(state, action) {
      const { key, value } = action.payload;
      let updatedValue = value;
      if (key === "priceType" || key === "job") {
        if (!value?.id) {
          updatedValue = initialState.tableSearchFields[key];
        } else {
          updatedValue = { ...value };
        }
      } else if (key === "district" || key === "storeNumber" || key === "laborCode" || key === "status") {
        updatedValue = [...value];
      }
      state.tableSearchFields = { ...state.tableSearchFields, [key]: updatedValue };
    },
    updateExpSearchData(state, action) {
      const { key, value } = action.payload;
      let updatedValue = value;
      if (key === "job") {
        if (!value?.id) {
          updatedValue = initialState.exceptionPriceSearchFields[key];
        } else {
          updatedValue = { ...value };
        }
      }
      state.exceptionPriceSearchFields = { ...state.exceptionPriceSearchFields, [key]: updatedValue };
    },
    showExpPrice(state, action) {
      state.isExpPrice = action.payload;
    },
    searchSubmit(state) {
      state.showTable = false;
    },
    searchSubmitSuccess(state, action) {
      const tableListNew = action.payload;
      state.tableList = tableListNew;
      state.showTable = true;
    },
    searchSubmitFailure(state) {
      state.tableList = initialState.tableList;
      state.showTable = true;
    },
    updatePricingData(state, action) {
      const editedPricingRow = action.payload;
      const tableListNew = JSON.parse(JSON.stringify(state.tableList));
      tableListNew[editedPricingRow.elementIndex] = editedPricingRow;
      state.tableList = tableListNew;
    },
    approveRejectPricing(state, action) {
      const tableListNew = JSON.parse(JSON.stringify(state.tableList));
      action.payload.map((item) => {
        tableListNew[item.elementIndex] = item;
      });
      state.tableList = tableListNew;
    },
    verifyCurrentRates(state, action) {
      const tableListNew = JSON.parse(JSON.stringify(state.tableList));
      action.payload.map((item) => {
        tableListNew[item.elementIndex] = item;
      });
      state.tableList = tableListNew;
    },
    getDistrictList(state, action) {
      state.districtList = action.payload;
    },
    getStoreNoList(state, action) {
      state.storeNumberList = action.payload;
    },
    getLaborCodeList(state, action) {
      state.laborCodeList = action.payload;
    },
    getStatusList(state, action) {
      state.statusList = action.payload;
    },
    updateSearchFilterValue(state, action) {
      state.searchFilterValue = action.payload;
    },
    clearCustomerFields(state) {
      state.tableSearchFields = initialState.tableSearchFields;
      state.showTable = initialState.showTable;
    },
    selectAll(state, action) {
      let isSelectAllChecked = state.isSelectAllChecked;
      let tableData = action.payload;
      const tableListNew = JSON.parse(JSON.stringify(state.tableList));
      if (isSelectAllChecked) {
        tableData.map((user) => {
          tableListNew[user.elementIndex].isSelected = false;
        });
        isSelectAllChecked = false;
      } else {
        tableData.map((user) => {
          tableListNew[user.elementIndex].isSelected = true;
        });
        isSelectAllChecked = true;
      }
      state.tableList = tableListNew;
      state.isSelectAllChecked = isSelectAllChecked;
    },
    customerRowSelection(state, action) {
      const tableListNew = [...state.tableList].map((item) => {
        if (item.laborCodeStoreId === action.payload) {
          return { ...item, isSelected: item.isSelected ? false : true };
        } else return { ...item };
      });
      state.tableList = tableListNew;
    },
    resetSelectedRows(state) {
      const tableListNew = state.tableList.map((item) => {
        if (item.isSelected) {
          return { ...item, isSelected: false };
        } else {
          return { ...item };
        }
      });
      state.tableList = tableListNew;
      state.isSelectAllChecked = false;
    },
    getExcepPrices(state, action) {
      state.exceptionPriceSearchList = action.payload;
      state.showPriceTable = true;
    },
  },
});

export const {
  updateSearchFields,
  updateExpSearchData,
  showExpPrice,
  searchSubmit,
  searchSubmitSuccess,
  searchSubmitFailure,
  updatePricingData,
  approveRejectPricing,
  verifyCurrentRates,
  getDistrictList,
  getStoreNoList,
  getLaborCodeList,
  getStatusList,
  updateSearchFilterValue,
  clearCustomerFields,
  selectAll,
  customerRowSelection,
  resetSelectedRows,
  getExcepPrices,
} = laborTable.actions;

export default laborTable.reducer;
